import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 text-right" }
const _hoisted_4 = {
  class: "btn btn-outline-secondary mr-1",
  style: {"padding":"0.7em 2em"}
}
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  class: "navbar navbar-light navbar-expand-md bg-light pl-1",
  role: "navigation"
}
const _hoisted_9 = {
  class: "btn-group mr-auto",
  role: "group"
}
const _hoisted_10 = {
  class: "form-inline my-2 my-lg-0",
  role: "search"
}
const _hoisted_11 = { class: "form-inline" }
const _hoisted_12 = { class: "dropdown" }
const _hoisted_13 = {
  class: "btn btn-outline-secondary btn-sm dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown"
}
const _hoisted_14 = { class: "dropdown-menu" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "table table-hover" }
const _hoisted_17 = {
  key: 0,
  class: "d-flex flex-row"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "text-muted text-nowrap" }
const _hoisted_20 = {
  key: 0,
  class: "fa fa-user text-success",
  title: "User"
}
const _hoisted_21 = {
  key: 1,
  class: "fa fa-user text-danger",
  title: "User access rejected"
}
const _hoisted_22 = {
  key: 2,
  class: "fa fa-user text-secondary",
  title: "User access requested"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "ml-auto" }
const _hoisted_25 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_26 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 1,
  class: "dropdown"
}
const _hoisted_33 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 1,
  class: "row"
}
const _hoisted_37 = { class: "col-6" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = { class: "error" }
const _hoisted_41 = { class: "col-6" }
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = { class: "error" }
const _hoisted_45 = { class: "col-12" }
const _hoisted_46 = { class: "dropdown d-inline-block" }
const _hoisted_47 = { class: "dropdown-menu" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "col-12 text-right" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectUsersTagsManager = _resolveComponent("ProjectUsersTagsManager")!
  const _component_ProjectUsersFromStringBuilder = _resolveComponent("ProjectUsersFromStringBuilder")!
  const _component_ProjectUserDeleter = _resolveComponent("ProjectUserDeleter")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ProjectUsersTagsManager, {
      viewModel: _ctx.projectUsersTagsManager,
      onCreateTag: _ctx.handleCreateProjectUsersTagCommand,
      onDeleteTag: _ctx.handleDeleteProjectUsersTagCommand,
      onUpdateTag: _ctx.handleUpdateProjectUsersTagCommand
    }, null, 8 /* PROPS */, ["viewModel", "onCreateTag", "onDeleteTag", "onUpdateTag"]),
    _createVNode(_component_ProjectUsersFromStringBuilder, {
      viewModel: _ctx.projectUsersFromStringBuilder,
      onCreateProjectUsers: _ctx.handleCreateProjectUsersCommand
    }, null, 8 /* PROPS */, ["viewModel", "onCreateProjectUsers"]),
    _createVNode(_component_ProjectUserDeleter, {
      viewModel: _ctx.projectUserDeleter,
      onDeleteProjectUser: _ctx.handleDeleteProjectUserCommand,
      onArchiveProjectUser: _ctx.handleArchiveProjectUserCommand
    }, null, 8 /* PROPS */, ["viewModel", "onDeleteProjectUser", "onArchiveProjectUser"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-lg-6" }, [
          _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "People")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [
            _createTextVNode("Assign " + _toDisplayString(_ctx.alternativesLabel), 1 /* TEXT */)
          ])), [
            [_directive_sanitizedHref, _ctx.url_ManageAssignmentsPage]
          ]),
          _createElementVNode("button", {
            role: "button",
            class: "btn btn-outline-secondary mr-1",
            style: {"padding":"0.7em 2em"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showTagsManager && _ctx.showTagsManager(...args)))
          }, "Manage tags"),
          _createElementVNode("button", {
            role: "button",
            class: "btn btn-success",
            style: {"padding":"0.7em 2em"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showProjectUsersFromStringBuilder && _ctx.showProjectUsersFromStringBuilder(...args)))
          }, "Add")
        ])
      ])
    ]),
    _cache[24] || (_cache[24] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_5, [
      (!_ctx.initialized)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_6, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Loading... ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.initialized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("nav", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-sm", { 'btn-secondary': !_ctx.archivedFilter, 'btn-outline-secondary': _ctx.archivedFilter }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.archivedFilter = false))
                }, " Active ", 2 /* CLASS */),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-sm", { 'btn-secondary': _ctx.archivedFilter, 'btn-outline-secondary': !_ctx.archivedFilter }]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.archivedFilter = true))
                }, " Archived ", 2 /* CLASS */)
              ]),
              _createElementVNode("form", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchPhrase) = $event)),
                  class: "form-control form-control-sm mr-sm-2",
                  type: "search",
                  placeholder: "Search"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.searchPhrase]
                ])
              ]),
              _createElementVNode("form", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", _hoisted_13, [
                    _createElementVNode("span", null, "Filter by: " + _toDisplayString(_ctx.tagFilter ?? "Show all"), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.tagFilter = null))
                    }, "Show all"),
                    _cache[8] || (_cache[8] = _createElementVNode("h6", { class: "dropdown-header" }, "By tag:", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (t) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "dropdown-item",
                        onClick: ($event: any) => (_ctx.tagFilter = t)
                      }, _toDisplayString(t), 9 /* TEXT, PROPS */, _hoisted_15))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_16, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectUsersView, (p) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: p.ProjectUserId
                  }, [
                    _createElementVNode("td", null, [
                      (!p.Editing)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", {
                              onClick: ($event: any) => (p.edit()),
                              class: "pointer",
                              style: {"width":"300px"}
                            }, [
                              _createElementVNode("span", null, _toDisplayString(p.Name), 1 /* TEXT */),
                              _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                              _createElementVNode("small", _hoisted_19, [
                                (p.IsUserAccepted)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                                  : _createCommentVNode("v-if", true),
                                (p.IsUserRejected)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                                  : _createCommentVNode("v-if", true),
                                (p.IsUserRequested)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                                  : _createCommentVNode("v-if", true),
                                _createTextVNode(" " + _toDisplayString(p.Email || 'No email'), 1 /* TEXT */)
                              ])
                            ], 8 /* PROPS */, _hoisted_18),
                            _createElementVNode("div", {
                              onClick: ($event: any) => (p.edit()),
                              class: "pointer"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Tags, (t) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: "badge badge-secondary mr-1",
                                  key: t
                                }, _toDisplayString(t), 1 /* TEXT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ], 8 /* PROPS */, _hoisted_23),
                            _createElementVNode("div", _hoisted_24, [
                              (!p.IsArchived)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _cache[12] || (_cache[12] = _createElementVNode("button", {
                                      class: "btn btn-outline-secondary dropdown-toggle",
                                      type: "button",
                                      "data-toggle": "dropdown"
                                    }, "Actions", -1 /* CACHED */)),
                                    _createElementVNode("div", _hoisted_26, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (p.edit())
                                      }, "Edit", 8 /* PROPS */, _hoisted_27),
                                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                      (!p.IsUserAccepted && !p.IsUserRequested && p.Email)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "dropdown-item",
                                            onClick: ($event: any) => (_ctx.handleRequestAccount(p))
                                          }, "Request an account", 8 /* PROPS */, _hoisted_28))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.handleResetProjectUserAccessTokenCommand(p))
                                      }, "Reset access links", 8 /* PROPS */, _hoisted_29),
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.handleArchiveProjectUserCommand(p.ProjectUserId))
                                      }, "Archive", 8 /* PROPS */, _hoisted_30),
                                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.showProjectUserDeleter(p))
                                      }, "Delete", 8 /* PROPS */, _hoisted_31)
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (p.IsArchived)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _cache[14] || (_cache[14] = _createElementVNode("button", {
                                      class: "btn btn-outline-secondary dropdown-toggle",
                                      type: "button",
                                      "data-toggle": "dropdown"
                                    }, "Actions", -1 /* CACHED */)),
                                    _createElementVNode("div", _hoisted_33, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.handleUnarchiveProjectUserCommand(p))
                                      }, "Unarchive", 8 /* PROPS */, _hoisted_34),
                                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.showProjectUserDeleter(p))
                                      }, "Delete", 8 /* PROPS */, _hoisted_35)
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (p.Editing)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _cache[15] || (_cache[15] = _createElementVNode("label", null, "Name", -1 /* CACHED */)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((p.NewName) = $event),
                                  type: "text",
                                  class: "form-control input-sm",
                                  placeholder: "Name"
                                }, null, 8 /* PROPS */, _hoisted_39), [
                                  [
                                    _vModelText,
                                    p.NewName,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createElementVNode("div", _hoisted_40, _toDisplayString(p.NameError), 1 /* TEXT */)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _cache[16] || (_cache[16] = _createElementVNode("label", null, "Email", -1 /* CACHED */)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "email",
                                  "onUpdate:modelValue": ($event: any) => ((p.NewEmail) = $event),
                                  class: "form-control input-sm",
                                  placeholder: "Email"
                                }, null, 8 /* PROPS */, _hoisted_43), [
                                  [
                                    _vModelText,
                                    p.NewEmail,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createElementVNode("div", _hoisted_44, _toDisplayString(p.EmailError), 1 /* TEXT */)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _cache[20] || (_cache[20] = _createElementVNode("label", null, "Tags", -1 /* CACHED */)),
                              _createElementVNode("div", _hoisted_46, [
                                _cache[17] || (_cache[17] = _createTextVNode(" (", -1 /* CACHED */)),
                                _cache[18] || (_cache[18] = _createElementVNode("a", {
                                  class: "text-primary",
                                  "data-toggle": "dropdown"
                                }, "add tag", -1 /* CACHED */)),
                                _cache[19] || (_cache[19] = _createTextVNode(") ", -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_47, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (t) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (p.addTag(t))
                                    }, _toDisplayString(t), 9 /* TEXT, PROPS */, _hoisted_48))
                                  }), 256 /* UNKEYED_FRAGMENT */))
                                ])
                              ]),
                              _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.NewTags, (t) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: "badge badge-secondary pointer mr-2",
                                  key: t,
                                  onClick: ($event: any) => (p.removeTag(t)),
                                  title: "remove a tag"
                                }, _toDisplayString(t) + " ×", 9 /* TEXT, PROPS */, _hoisted_49))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.handleUpdateProjectUserCommand(p)),
                                class: "btn btn-primary btn-sm",
                                title: "confirm"
                              }, [...(_cache[22] || (_cache[22] = [
                                _createElementVNode("span", { class: "fa fa-check" }, null, -1 /* CACHED */)
                              ]))], 8 /* PROPS */, _hoisted_51),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (p.cancelEdit()),
                                class: "btn btn-outline-secondary btn-sm",
                                title: "cancel"
                              }, [...(_cache[23] || (_cache[23] = [
                                _createElementVNode("span", { class: "fa fa-times" }, null, -1 /* CACHED */)
                              ]))], 8 /* PROPS */, _hoisted_52)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}